import { singleton } from 'tsyringe';
import { PromotionDisplayDetails } from '../../shared/models/promotion-display-details.model';
import { LoggerService } from '../../shared/services/logger.service';
import { OWWrapper } from '../../shared/wrappers/ow-wrapper';

import { OWExtensionWrapper } from '../ow-odk-wrappers/ow-extension-wrapper';
import { OWSettingsWrapper } from '../ow-odk-wrappers/ow-settings-wrapper';
import { PersistentStorageService } from './persistent-storage-service/persistent-storage.service';
import configurations from '../../configurations.json';
import { PromotionType } from './datastore-service/models/raw-promotion.model';
// -----------------------------------------------------------------------------
@singleton()
export class PromotionDetailsBuilderService {
  private readonly logger = LoggerService.getCategory('PromotionDetails');

  // ---------------------------------------------------------------------------
  public constructor(
    private readonly owSettingsWrapper: OWSettingsWrapper,
    private readonly persistentStorage: PersistentStorageService,
    private readonly owWrapper: OWWrapper,
    private readonly owExtensionWrapper: OWExtensionWrapper,
  ) {}

  // ---------------------------------------------------------------------------
  public async getPromotionDetails(
    gameId: number,
    promotionId: string,
    promotionType: PromotionType,
    useDevEnv: string,
  ) {
    return this.createPromotionDetails(
      gameId,
      promotionId,
      promotionType,
      await this.buildUrlWithParameters(
        gameId,
        promotionId,
        promotionType,
        useDevEnv,
      ),
    );
  }

  // ---------------------------------------------------------------------------
  private async createPromotionDetails(
    gameId: number,
    promotionId: string,
    promotionType: PromotionType,
    url: string,
  ): Promise<PromotionDisplayDetails> {
    return {
      promotionId,
      gameId,
      url,
      promotionType,
    };
  }

  // ---------------------------------------------------------------------------
  private async buildUrlWithParameters(
    gameId: number,
    promotionId: string,
    promotionType: PromotionType,
    useDevEnv: string,
  ) {
    try {
      const lang = await this.owSettingsWrapper.getLanguage();
      const appVersion = await this.getAppVersion();
      const timestamp = Date.now();
      let promotionIframeURL = this.getPromotionIframeURL(promotionType);

      if (useDevEnv) {
        promotionIframeURL = promotionIframeURL.replace('prod', useDevEnv);
      }

      const iframeURL = new URL(promotionIframeURL);
      iframeURL.searchParams.append('gameId', gameId.toString());
      iframeURL.searchParams.append('promoId', promotionId);
      iframeURL.searchParams.append('version', this.owWrapper.getVersion());
      iframeURL.searchParams.append('appVersion', appVersion);
      iframeURL.searchParams.append('lang', lang);
      iframeURL.searchParams.append('timestamp', timestamp.toString());
      if (useDevEnv) {
        iframeURL.searchParams.append('localeEnv', useDevEnv);
      }

      return iframeURL.toString();
    } catch (e) {
      this.logger.error('Failed to gather parameters, exception details:', e);
      return null;
    }
  }

  // ---------------------------------------------------------------------------
  // private selectedTargetGameId(game: Game) {
  //   return game.targetGameId ? game.targetGameId : game.id;
  // }

  // ---------------------------------------------------------------------------
  private async getAppVersion() {
    await this.owExtensionWrapper.initialize();
    const appVersion = this.owExtensionWrapper?.manifest?.meta?.version;
    return appVersion;
  }

  // ---------------------------------------------------------------------------
  private getPromotionIframeURL(promotionType: PromotionType): string {
    return promotionType === PromotionType.Offer
      ? configurations.generalConfiguration.promotionOfferIframeURL
      : configurations.generalConfiguration.promotionIframeURL;
  }
}
